<template>
    <el-form
      ref="form"
      :model="forms"
      :rules="rules"
    >
        <el-form-item :label="item.name" :prop="item.attr" v-for="(item, index) in form" :key="index">
          <template v-if="item.type === 'cascader'">
            <el-cascader
              v-model="forms.model_cascader"
              :props="{
                value: 'id',
                label: 'name',
                children: 'recursive_children',
                checkStrictly: true,
              }"
              :options="item.options"
              clearable
            ></el-cascader>
            <el-input type="hidden" v-model="forms.cascader"></el-input>
          </template>

          <el-input v-else v-model="forms[item.attr]" :placeholder="item.props.placeholder"/>
        </el-form-item>
    </el-form>
</template>

<script>

export default {
    name: 'ele_form',
    props: {
        form: {
            type: Array,
            default: [],
        },
      isSubmit: {
          type: Boolean,
          default: false
      }
    },
	data () {
    	return {
        forms: {},
        rules: {},
        forms_cascader: [],
      };
	},
	created() {
		const _r = {};
		const _f = {};

		this.form.forEach(val => {
			_r[val.attr] = [val.props.rules];
			_f[val.attr] = val.value || '';
		});

		this.forms = _f;
		this.rules = _r;
	},
  watch: {
    isSubmit (val) {
      if (val) {
        this.$refs.form.validate(valid => {
          this.$emit('onAttr', valid, this.forms);
        })
      }
    },
    'forms.model_cascader' (val) {
      this.forms.cascader = val.join(',');
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/EleForm/index.vue